
import {
  billingCycleDependBasePlanTypeList,
  licenseDependBasePlanTypeList,
  planTypes,
} from '@/common/constants';
import { defaultMapper } from "@/common/service/default-mapper";
import { flowTypes, pageConfig } from '@/common/service/page-config';

const cmrKey = ['videosdk_cmr_1TB']
const { type: flowType } = pageConfig || {};
if (flowType === flowTypes.edit) cmrKey.unshift('videosdk_cmr_5TB')
const BASE_UNIT = 1024

export default (planMapJSON) => {
    return cmrKey.reduce((pre, key) => {
        return [
            ...defaultMapper(planMapJSON[key], planTypes.LDKCMR).map(item => 
                {
                const { capacity, minuteExcessPrice, minuteCapacity ,excessPrice }  = planMapJSON[key]
                return {
                    ...item,
                    capacity,
                    typeNameKey: 'billing.planform.title.ldk_cmr',
                    planNameKey: 'billing.planform.title.ldk_cmr',
                    dependBasePlanTypeList: [planTypes.VIDEO_SDK],
                    billingCycleDependBasePlanTypeList,
                    licenseDependBasePlanTypeList,
                    cartCapacityUnit: capacity < BASE_UNIT ? 'GB' : 'TB',
                    cartCapacity: capacity < BASE_UNIT ? capacity : Math.floor(capacity / BASE_UNIT),
                    supportCoupon: false,
                    minuteCapacity,
                    minuteExcessPrice,
                    excessPrice
                    }
                }),
            ...pre,
        ]
    }, []);
}
